import { Button } from 'antd'

import Styled from './styled'

export default function MyButton(props) {
  const buttonProps = {
    shape: 'round',
    ...props,
  }

  return (
    <Styled className="button-component">
      <Button {...buttonProps} />
    </Styled>
  )
}
